import { PopoverDirective } from "./popover.directive";
export * from "./popover.directive";
export var POPOVER_DIRECTIVES = [
    PopoverDirective
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/common/index.js
// module id = 301
// module chunks = 4